// frontend/src/pages/mind-mesch/PartnerApi.js

import React from 'react';
import MindMeschLayout from '../../components/mind-mesch/MindMeschLayout';
import { Link } from 'react-router-dom';

const PartnerApi = () => {
  return (
    <MindMeschLayout>
      <section className="hero-section">
        <h1 className="hero-title">Let Your App Remember What Matters</h1>
        <p className="hero-subtitle">
          The Mind Mesch API powers memory, emotion, and intent — so your app can connect on a deeper level.
        </p>
        <a href="#benefits" className="cta-button">Explore the API</a>
      </section>

      <section id="benefits" className="benefits-section">
        <h2>3 Overt Benefits</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <h3>Effortless Memory Recall</h3>
            <p>Let your app store and retrieve meaningful user memories automatically — no backend required.</p>
            <ul>
              <li>✅ Perfect for: journals, coaching, therapy</li>
              <li>✅ Tracks content, time, emotion</li>
              <li>✅ Secure, persistent memory store</li>
            </ul>
          </div>

          <div className="benefit-card">
            <h3>Emotion + Intent Intelligence</h3>
            <p>Each entry is auto-tagged with tone, emotion, and user intent for smarter experiences.</p>
            <ul>
              <li>✅ Detect motivation, fear, joy, reflection</li>
              <li>✅ Adapt UX to emotional states</li>
              <li>✅ Great for wellness & personal growth</li>
            </ul>
          </div>

          <div className="benefit-card">
            <h3>Plug-and-Play Simplicity</h3>
            <p>One API key. Three routes. Your app becomes unforgettable — instantly.</p>
            <ul>
              <li>✅ POST memories, GET insights</li>
              <li>✅ Usage quotas & key security built in</li>
              <li>✅ Dev-ready in under an hour</li>
            </ul>
          </div>
        </div>
        <Link to="/partner-api/docs" className="cta-button-secondary">View API Docs</Link>
      </section>
    </MindMeschLayout>
  );
};

export default PartnerApi;
